import { useConfig } from '@cp/shared/config';
import { useCareerDeclination } from '@cp/entities/career';
import { ClientType } from '@common/model/client/clientType';
import { useClientProfile } from 'src/entities/client';

export const useExternalMessangerResponseTemplate = (): string | undefined => {
  const config = useConfig();
  const profile = useClientProfile();
  const careerDeclination = useCareerDeclination();
  const appName = config.get('APP_NAME');
  if (profile?.type !== ClientType.Specialist) {
    return;
  }
  return `Здравствуйте, я ${profile.mainCareerId ? careerDeclination(1, profile.mainCareerId) : ''} от Виолетты с сайта ${appName ? appName.toLowerCase() + '.ru' : ''} по поводу вашей вакансии`;
};
